import {
  SurveyBaseAllBaseReadSurveyAllSurveyRead,
  SurveyQuestionAnswerBaseAllBaseWriteSurveyQuestionAnswerAllSurveyQuestionAnswerWrite
} from '../../openapi';
import { createAction, props } from '@ngrx/store';

export const sendAnswer = createAction(
  '[Surveys] send answers',
  props<{
    items: SurveyQuestionAnswerBaseAllBaseWriteSurveyQuestionAnswerAllSurveyQuestionAnswerWrite[],
    successFunc: () => void
  }>()
);

export const sendAnswerSuccess = createAction(
  '[Surveys] send answers success'
);

export const sendAnswerFailure = createAction(
  '[Surveys] send answers failure'
);

export const loadCollection = createAction(
  '[Surveys] load collection'
);

export const loadCollectionSuccess = createAction(
  '[Surveys] load collection success',
  props<{ collection: SurveyBaseAllBaseReadSurveyAllSurveyRead[] }>()
);

export const loadCollectionFailure = createAction(
  '[Surveys] load collection failure'
);
